import * as React from "react";
import { TeamScore } from "../TeamScore";
import { TeamName } from "../TeamName";
import { Table } from "../Table";
import { TennisScore } from "../../data/models";

export class TennisScoreboard extends React.Component<{ tennisData: TennisScore, team1Name: string, team2Name: string }, {}> {

    renderRow(player, teamName, indexTeam) {
        return (<Table.Row key={`row-${player}`} classes={`rj-sports-multiview__scoreboard-row-team-${indexTeam}`}>
                    {this.renderTeamName(teamName, indexTeam)}
                    {this.renderSets(player)}
                    {this.renderPoints(player, this.props.tennisData[player + "Points"])}
                </Table.Row>);
    }

    renderSets(player) {
        const sets = this.props.tennisData.matchType === 5 ? [1,2,3,4,5] : [1,2,3];
        return sets.map((index) => {
                let currScore = this.props.tennisData[player + `Set${index}`];
                return (
                    (currScore !== "") &&
                    <Table.Cell key={`set-${player}-${index}`} additionalClassNames="rj-sports-multiview__scoreboard-item rj-sports-multiview__scoreboard-item--set">
                        <TeamScore score={currScore} modifier={"rj-sports-multiview__scoreboard-item--set-teamscore"} />
                    </Table.Cell>
                )
            }
        );
    }

    renderPoints(player, score) {
        return  (
                (score !== "") &&
                <Table.Cell key={`total-points-${player}`} additionalClassNames={`rj-sports-multiview__scoreboard-item rj-sports-multiview__scoreboard-item--total`}>
                    <TeamScore score={score} modifier="rj-sports-multiview__scoreboard-item--total-teamscore"/>
                </Table.Cell>);
    }

    renderTeamName(name, indexTeam) {
        let servingMark = this.props.tennisData.servs === 0 || this.props.tennisData.servs === 1  ? `rj-sports-multiview__teamscore-${this.props.tennisData.servs}` : "";
        return (<Table.Cell additionalClassNames={`rj-sports-multiview__scoreboard-item rj-sports-multiview__scoreboard-item--team ${servingMark}`}>
                    <span className="rj-sports-multiview__possession"></span>
                    <TeamName dataUat={`div-multiview-team-${indexTeam}`} name={name} modifier={`rj-sports-multiview__scoreboard-item--teamname `}/>
                </Table.Cell>);
    }

    render() {
        const firstTeamName = this.props.team1Name;
        const secondTeamName = this.props.team2Name;

        return (
            <div className="rj-scoreboard rj-sports-multiview__scoreboard ">
                <Table.Root modifier="rj-sports-multiview__scoreboard-table rj-sports-multiview__scoreboard-table--tennis">
                    <Table.Body>
                        {this.renderRow("player1", firstTeamName, 0)}
                        {this.renderRow("player2", secondTeamName, 1)}
                    </Table.Body>
            </Table.Root>
        </div>
        )
    }
}